export const getPrimaryPhoneNumber = (phoneNumbers) => {
  if (phoneNumbers) {
    const primaryPhoneObj = phoneNumbers.find(phoneObj => phoneObj.isPrimary);

    if (primaryPhoneObj) {
      return primaryPhoneObj.number;
    }
  }
};

export const getDecimalsCount = (number) => {
  if (Math.floor(number) === Number(number)) {
    return 0;
  }

  return `${number}`.split('.')[1].length || 0;
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js